// extracted by mini-css-extract-plugin
export default {"identity":"k9Q2P3xIHxw4xSiA5yGt","edit-record":"a10dbehzThKI6ICjyqgb","highlight":"NnRnZsRR928_5lQxuMBw"};